import { axiosRequest } from "../../configs/axios.config";

export class LandingPageService {
  updateRecord(idLandingPage, dataParams, success, error) {
    axiosRequest
      .put(`/landing_pages/${idLandingPage}`, dataParams)
      .then((data) => success(data))
      .catch((err) => error(err));
  }
}
